import React, { Component } from "react";
import { connect } from "react-redux";
import config from "../../../config";
import WorkflowStep from "./WorkflowStepContainer/WorkflowStepContainer";
import { silentFetchWorkflow } from "../../../redux/modules/workflow/actions";

import {
  IWorkflow,
  IWorkflowAction,
  IWorkflowStep,
} from "../../../redux/modules/currentWorkflow/reducer";
import { style } from "typestyle";
import { White } from "@traceair/tds";
import {
  getWorkflowInputStepPermission,
  getWorkflowActionPermission,
  getWorkflowRollbackPermission,
} from "../../../redux/modules/workflow/strings";
import { AppDispatch } from "../../../store";

interface IWorkflowContainerProps {
  customerId: string;
  siteId: string | null;
  workflow: IWorkflow;
  dispatch: AppDispatch;
  onStepSubmit: (
    step: IWorkflowStep,
    modifiedActions: IWorkflowAction[],
  ) => void;
}
class WorkflowContainer extends Component<IWorkflowContainerProps> {
  updateIntervalId: number;

  componentDidMount() {
    const { dispatch, workflow, customerId, siteId } = this.props;

    if (!siteId) {
      // no need to support background refresh for customer-level workflow
      return;
    }

    this.updateIntervalId = window.setInterval(
      () => dispatch(silentFetchWorkflow(customerId, siteId, workflow.id)),
      config.workflowUpdateInterval,
    );
  }

  componentWillUnmount() {
    this.updateIntervalId && clearInterval(this.updateIntervalId);
  }

  render() {
    const { workflow, siteId, customerId } = this.props;
    const { steps, workflowType } = workflow;

    return (
      <div
        className={style({
          padding: "0",
          color: "rgba(0,0,0,0.87)",
          fontSize: "16px",
          lineHeight: "24px",
        })}
      >
        <div
          className={style({
            width: "100%",
            boxShadow: "0 1px 6px rgba(0,0,0,.12), 0 1px 4px rgba(0,0,0,.24);",
            background: White,
            borderRadius: "2px",
          })}
        >
          {steps.map((step) => {
            return (
              <WorkflowStep
                key={step.title}
                step={step}
                siteId={siteId}
                customerId={customerId}
                requiredActionPermissions={[
                  getWorkflowActionPermission(workflowType),
                  getWorkflowInputStepPermission(workflowType),
                ]}
                requiredRollbackPermissions={[
                  getWorkflowRollbackPermission(workflowType),
                ]}
                onSubmit={(modifiedActions: IWorkflowAction[]) =>
                  this.props.onStepSubmit(step, modifiedActions)
                }
              />
            );
          })}
        </div>
      </div>
    );
  }
}

export default connect()(WorkflowContainer);
